import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogoSmall } from '@/components/Logo';

/**
 * Unified public footer for all pages
 */
export default function PublicFooter() {
  const { t } = useTranslation();

  return (
    <footer className="py-8 sm:py-12 px-4 sm:px-6 md:px-12 border-t border-border/50 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between mb-6">
          <Link to="/">
            <LogoSmall />
          </Link>
          <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm text-muted-foreground flex-wrap justify-center">
            <Link to="/chapters" className="hover:text-foreground transition-colors" data-testid="footer-chapters-link">
              Gita Verses
            </Link>
            <Link to="/quotes" className="hover:text-foreground transition-colors" data-testid="footer-quotes-link">
              Gita Quotes
            </Link>
            <Link to="/about" className="hover:text-foreground transition-colors" data-testid="footer-about-link">
              {t('landing.footer_about')}
            </Link>
            <Link to="/contact" className="hover:text-foreground transition-colors" data-testid="footer-contact-link">
              {t('landing.footer_contact')}
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">
              {t('landing.footer_privacy')}
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms-link">
              {t('landing.footer_terms')}
            </Link>
          </div>
          <p className="text-xs text-muted-foreground">
            {t('landing.footer_nonprofit')}
          </p>
        </div>
        <div className="text-center text-xs text-muted-foreground/60 leading-relaxed max-w-3xl mx-auto">
          <p>{t('landing.footer_desc')}</p>
        </div>
      </div>
    </footer>
  );
}
